import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut } from './utils'

export const getGranteeForStaff = (projectVersionId) => {
  // /api/approval/{projectVersionId}/review/grantee
  const url = `${API_ROOT}/approval/${projectVersionId}/review/grantee`
  return doGet(url)
}

// ---------------------------------- subproject
export const getGranteeForStaffSubProject = (projectVersionId) => {
  // /api/subproject/{projectVersionId}/grantee-profile
  const url = `${API_ROOT}/subproject/${projectVersionId}/grantee-profile`
  return doGet(url)
}
// ----------------------------------
